import * as React from "react";

import "./delete-card-modal.scss";

import {cs}           from "@Common/react/chain-services";
import {DeprecatedModalService2} from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const DeleteCardModal = ({next: rootNext}) => cs(
    ["modal", (_, next) => <DeprecatedModalService2 {...{
        render: ({onYes, messageLines}, rm) => ({
            content: next({onYes, messageLines, close: () => rm()}),
        }),
        next: rootNext,
    }}/>],
    ({modal}) => (
        <div className="delete-card-modal-1wi">
            <div className="message" xd-qa-type="label" xd-qa-name="Remove Message">
                {modal.messageLines.map((messageLine, i) => (
                    <p {...{
                        key: i,
                        ...i===0 && {
                            "xd-qa-type": "label",
                            "xd-qa-name": messageLine,
                        },
                    }}>
                        {messageLine}
                    </p>
                ))}
            </div>
            <div className="footer">
                <button
                    className="cancel"
                    onClick={modal.close}
                    xd-qa-type="button"
                    xd-qa-name="Remove Cancel"
                >
                    Cancel
                </button>
                <button
                    className="yes"
                    onClick={() => {
                        modal.onYes();
                        modal.close();
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Remove Yes"
                >
                    Yes
                </button>
            </div>
        </div>
    )
);